import React from "react"
import Header from "../components/header"
import Footer from "../components/footer"
import IndustryHeader from "../components/industryHeader"
import IndustryFeature from "../components/industryFeature"
import { IconIndustry911 } from "../components/icons"
import { ImageFeature911NonEmergencyServices, ImageFeature911RequestAdditionalInformation, ImageFeature911AutomaticTextStatusUpdates, ImageFeature911CallTakerPerformanceSurvey, ImageFeature911PositiveCitizenFeedback, ImageFeature911CPSS, ImageFeature911ResponseRate } from "../components/images"
import "../styles/styles.sass"
import { Helmet } from 'react-helmet'
import SEO from "../components/seo";

export default function Industry911() {
  return <div className="landingView industryView industry911">
    <SEO
      title={"CueHit - 911"}
      description={"Configure your assistant with data from 911 and CAD to automate delivery of text and surveys to your callers."}/>

    <Header />
    
    <div className="landingContent">
      <IndustryHeader
        headerTitle="911"
        headerSubtitle="Configure your assistant with data from 911 and CAD to automate delivery of text and surveys to your callers."
        headerIcon={<IconIndustry911 />}
      />

      <IndustryFeature
        featureID="feature1"
        featureHeading="Automatic Text Notifications from CAD"
        featureTitle="Automatic text updates from CAD."
        featureDescription="From pre-arrival instructions, referrals to other agencies to ETA’s, a Rules Engine determines what texts are sent to which callers."
        featureImage={<ImageFeature911AutomaticTextStatusUpdates />}
        featureLayout="side right"
      />

      <IndustryFeature
        featureID="feature2"
        featureHeading="Surveys After 911 Calls"
        featureTitle="Easy SMS surveys to measure community satisfaction."
        featureDescription="Automatic text surveys sent a few hours or a few days after 9-1-1 calls to measure satisfaction of callers for non-critical incidents."
        featureImage={<ImageFeature911CallTakerPerformanceSurvey />}
        featureLayout="side left"
      />

      <IndustryFeature
        featureID="feature3"
        featureHeading="Positive Citizen Feedback"
        featureTitle="Improve staff morale with positive citizen feedback."
        featureDescription="Dynamic positive feedback board for display throughout the department."
        featureImage={<ImageFeature911PositiveCitizenFeedback />}
      />

      <IndustryFeature
        featureID="feature4"
        featureHeading="Data Analytics and Dashboards"
        featureTitle="Measure your reach."
        featureDescription="Analyze response rates to surveys over time and by type of incident to measure engagement. Many 9-1-1 centers are seeing greater than 50% response rates!"
        featureImage={<ImageFeature911ResponseRate />}
        featureLayout="side left"
      />

      <IndustryFeature
        featureID="feature5"
        featureHeading="Citizen Positive Satisfaction Score"
        featureTitle="Quantify your Engagement."
        featureDescription="CueHit agencies are seeing higher than 90% positive satisfaction ratings from their communities."
        featureImage={<ImageFeature911CPSS />}
      />

    </div>

    <Footer/>
  </div>
}
